import { VolumeDiscountRepository } from "public/repository/volume-discount.repository";

/**
 * @type {{name: string, timestamp: number}}
 */
const metadata = {
  name: "add-missing-style-volume-discount",
  timestamp: new Date("2025-06-30").getTime(),
};

/**
 * Add missing style to volume discounts
 * @param {Object} args
 * @param {Object} args.settings
 * @param {string} args.settings.namespace
 */
async function migrate({ settings }) {
  const volumeDiscountRepository = new VolumeDiscountRepository(settings);
  const volumeDiscounts = await volumeDiscountRepository.getAll();

  if (volumeDiscounts.items.length <= 0) {
    return;
  }

  if (volumeDiscounts.items.length >= 500) {
    console.log(
      `migrate:Volume Discounts collection is too large to migrate`,
      metadata.name
    );
    return;
  }

  const defaultStyle = volumeDiscountRepository.getDummyData().style;

  for (const volumeDiscount of volumeDiscounts.items) {
    console.log(metadata.name, volumeDiscount, "Checking volume discount");

    if (volumeDiscount.style && Object.keys(volumeDiscount.style).length > 0) {
      console.log(
        metadata.name,
        volumeDiscount._id,
        "Volume discount already has style"
      );

      continue;
    }

    console.log(
      metadata.name,
      volumeDiscount._id,
      "Adding missing style to volume discount"
    );

    await volumeDiscountRepository.update({
      ...volumeDiscount,
      style: defaultStyle,
    });
  }
}

export default { metadata, migrate };
